import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import { keyframes, css } from '@emotion/react';
import { border, grid, elevation, spacing } from '@hubble/tokens/web';
import { StyledForm } from '../../forms/Form/index.js';
import { SectionMessageFormErrorsWrapper } from '../../SectionMessage/SectionMessageFormErrors/index.js';
import { Content } from '../../shared/Content/index.js';
import { mediaQuery } from '../../primitives/media-queries.js';

const DIALOG_TOP = '10%';
const ALERT_WIDTH = 420;
const DIALOG_WIDTH = 496;
const SHEET_WIDTH = 496;
const popIn = keyframes`
  from {
    transform: translate(0, 8px) scale(0.9);
  }
  to {
    transform: translate(0, 0) scale(1);
  }
`;
const popOut = keyframes`
  from {
    transform: translate(0, 0) scale(1);
  }
  to {
    transform: translate(0, 8px) scale(0.9);
  }
`;
const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translate(0, 20%);
  }
  to {
    opacity: 1;
    transform: translate(0, 0);
  }
`;
const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translate(0, 0);
  }
  to {
    opacity: 0;
    transform: translate(0, 20%);
  }
`;
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const ContainerBase = _styled('div', {
  shouldForwardProp: isPropValid,
  target: "e1a37g82"
})("background-color:", ({
  theme
}) => theme.colorScheme.elevated.background.modal, ";border-radius:", border.radius.lg, ";position:fixed;width:100%;max-width:clamp(\n    300px,\n    calc(100% - ", grid.main.xs.margin, " - ", grid.main.xs.margin, "),\n    ", DIALOG_WIDTH, "px\n  );max-height:calc(100vh - ", DIALOG_TOP, " - ", DIALOG_TOP, ");z-index:9999;display:flex;flex-direction:column;box-shadow:", ({
  theme
}) => !theme.isDark && elevation.sheet, ";:not(:has([data-footer])){", Content, "{padding-block-end:", spacing[24], ";}}", StyledForm, "{flex-grow:1;overflow:auto;>*+*{margin-top:initial;}", Content, ">*+*{margin-top:", spacing[24], ";}", SectionMessageFormErrorsWrapper, "{padding-inline:", spacing[24], ";padding-block-end:", spacing[24], ";}}& [data-header]{flex-shrink:0;}& [data-footer]{flex-shrink:0;position:sticky;bottom:0;border-radius:0 0 ", border.radius.lg, " ", border.radius.lg, ";background-color:", ({
  theme
}) => theme.colorScheme.elevated.background.modal, ";}", props => !props.disableAnimation && css("@media (prefers-reduced-motion: no-preference){animation-duration:300ms;animation-timing-function:cubic-bezier(0.2, 0.8, 0.4, 1);transform-origin:var(--transform-origin);&[data-state='open']{animation-name:", popIn, ";}&[data-state='closed']{animation-name:", popOut, ";}}"), " &[data-variant='alert']{max-width:clamp(300px, calc(100% - 32px), ", ALERT_WIDTH, "px);}&[data-variant='dialog']{top:", DIALOG_TOP, ";@media ", mediaQuery.mobileXsDown, "{top:unset;bottom:0;height:fit-content;max-width:100%;max-height:calc(100% - ", DIALOG_TOP, ");border-radius:", border.radius.lg, " ", border.radius.lg, " 0 0;&[data-state='open']{animation-name:", slideIn, ";animation-duration:400ms;}&[data-state='closed']{animation-name:", slideOut, ";animation-duration:400ms;}}}&[data-variant='sheet']{max-width:clamp(300px, calc(100% - 32px), ", SHEET_WIDTH, "px);&[data-side='left']{left:40px;}&[data-side='right']{right:40px;}&[data-align='top']{top:40px;}&[data-align='bottom']{bottom:40px;}&[data-align='max']{top:40px;bottom:40px;max-height:unset;}@media ", mediaQuery.mobileXsDown, "{&[data-side='left'],&[data-side='right'],&[data-align='top'],&[data-align='bottom'],&[data-align='max']{height:fit-content;max-width:100%;max-height:calc(100% - ", DIALOG_TOP, ");top:unset;left:0;right:0;bottom:0;border-radius:", border.radius.lg, " ", border.radius.lg, " 0 0;&[data-state='open']{animation-name:", slideIn, ";animation-duration:400ms;}&[data-state='closed']{animation-name:", slideOut, ";animation-duration:400ms;}}&[data-align='max']{height:100%;top:", DIALOG_TOP, ";left:0;right:0;bottom:0;}}}");
const ContainerWrapper = _styled('div', {
  shouldForwardProp: isPropValid,
  target: "e1a37g81"
})("display:flex;align-items:center;justify-content:center;position:fixed;inset:0;z-index:9998;overflow:auto;", props => !props.disableAnimation && css("@media (prefers-reduced-motion: no-preference){animation-duration:300ms;animation-timing-function:cubic-bezier(0.2, 0.8, 0.4, 1);&[data-state='open']{animation-name:", fadeIn, ";}&[data-state='closed']{animation-name:", fadeOut, ";}}"), ";");
const OverlayBase = _styled('div', {
  shouldForwardProp: isPropValid,
  target: "e1a37g80"
})("background-color:", ({
  theme
}) => theme.colorScheme.elevated.background.overlay, ";position:fixed;inset:0;z-index:9998;", props => !props.disableAnimation && css("@media (prefers-reduced-motion: no-preference){animation-duration:300ms;animation-timing-function:cubic-bezier(0.2, 0.8, 0.4, 1);&[data-state='open']{animation-name:", fadeIn, ";}&[data-state='closed']{animation-name:", fadeOut, ";}}"), ";");

export { ContainerBase, ContainerWrapper, OverlayBase };
